import { render } from "./ExsudativeSection.vue?vue&type=template&id=f9895b92"
import script from "./ExsudativeSection.vue?vue&type=script&lang=js"
export * from "./ExsudativeSection.vue?vue&type=script&lang=js"

import "./ExsudativeSection.vue?vue&type=style&index=0&id=f9895b92&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__